// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import RichTextController from "./rich_text_controller"
application.register("rich-text", RichTextController)
